import productMockTemplatesApiClient, {
  PaginatedProductMockTemplates,
} from '../../../api/productMockTemplates';
import useKlydoQuery from '../../../hooks/useKlydoQuery';

const TEN_MINUTES_MS = 1000 * 60 * 10;
const ONE_HOUR_MS = 1000 * 60 * 60;

const useProductMockTemplatesQuery = (skip = 0, limit = 100) => {
  return useKlydoQuery<PaginatedProductMockTemplates>({
    queryKey: ['productMockTemplates', skip, limit],
    queryFn: () => productMockTemplatesApiClient.getTemplates(skip, limit),
    staleTime: TEN_MINUTES_MS,
    gcTime: ONE_HOUR_MS,
  });
};

export default useProductMockTemplatesQuery;
